<template>
  <span>
    <div v-for="(award, index) in reverseAwards(projectAwards, true)"
         :data-balloon="$t(award.name)"
         data-balloon-pos="up-right"
         :class="{
           'award_isef': $isIsef,
           'award_submission' : isSubmission,
           'award_isef_viewAll': isViewAll
         }"
         v-bind:style="{'z-index': (index + 5),
          'left': spaceBetweenAwards * (projectAwards.length - index - 1.5 ) + 'px'}"
         :key="award.id">
      <img v-if="award.showRibbon" :src="award.image" :alt="$t(award.name)"/>
    </div>
  </span>
</template>

<script>
import base from '../../mixins/base'

export default {
  mixins: [base],
  props: ['projectAwards', 'isStemExpo', 'isCareerHall', 'isViewAll'],
  methods: {
    reverseAwards: function (awards, reverse) {
      if (reverse) return awards.slice().reverse()
      return awards
    }
  },
  computed: {
    isSubmission: function () {
      return this.$route.fullPath.includes('submission')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
.award {
  position: absolute;
  width: 13%;
  @include touch {
    width: 15%;
  }
  &_ysc {
    top: 85% !important;
  }
}
.award_stemexpo {
  position: absolute;
  height: 45px;
  width: 36px;
  bottom: 40px !important;
  @include tablet-only {
    top: 40px
  }
  @include mobile {
    top: 45px;
  }
}
.award_submission {
  position: absolute;
  top: 260px !important;
  left: 290px !important;
  width: 36px;
  height: 45px;
}
.award_isef {
  position: absolute;
  width: 36px;
  height: 45px;
  top: -10px;
  &_viewAll {
    bottom: 22px !important;
    @include tablet {
      top: inherit !important;
    }
    @include mobile {
      top: inherit !important;
    }
  }
}
</style>
